const breakpoints = {
  values: {
    xs: 0,
    desktop: 740,
    mobile: 480,
  },
};

export default breakpoints;
